import React from "react";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useAppContext } from "providers/AppProvider";

const renderTooltip = (props) => (
  <Tooltip style={{ position: "fixed" }} id="button-tooltip" {...props}>
    {/* Toggle Navigation */}
  </Tooltip>
);

const ToggleButton = () => {
  const {
    config: { isNavbarVerticalCollapsed, isFluid, isRTL },
    setConfig,
  } = useAppContext();

  const handleClick = () => {
    document
      .getElementsByTagName("html")[0]
      .classList.toggle("navbar-vertical-collapsed");
    setConfig("isNavbarVerticalCollapsed", !isNavbarVerticalCollapsed);
  };

  return (
    <div className="toggle-icon-wrapper">
      <Button
        variant="link"
        className="navbar-toggler-humburger-icon navbar-vertical-toggle"
        id="toggleNavigationTooltip"
        onClick={handleClick}
      >
        <span className="navbar-toggle-icon">
          <span className="toggle-line" />
        </span>
      </Button>
    </div>
  );
};

export default ToggleButton;
